// MyMultiSelect.js
import { Component } from "react"
import { MultiSelect } from "react-multi-select-component"
class MyMultiSelect extends Component {
  constructor(props) {
    super(props)
    this.state = { selected: [] }
  }

  handleChange = (selected) => {
    this.setState({ selected })
    if (this.props.onChange) {
      this.props.onChange(selected)
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ selected: this.props.value || [] })
    }
  }
  render() {
    const {
      className,
      options,
      disabled = false,
      hasSelectAll = false,
    } = this.props
    return (
      <>
        <MultiSelect
          className={className}
          options={options}
          value={this.state.selected}
          onChange={this.handleChange}
          labelledBy="Select"
          hasSelectAll={hasSelectAll}
          disabled={disabled}
        />
      </>
    )
  }
}

export default MyMultiSelect
